import { useState } from "react";
import { CrudTable, StatusBadge, Card } from "@/components/shared";

const ISSUE_TYPES = ["Billing Dispute", "Unsatisfactory Result Concern", "Miscommunication", "Appointment Rescheduling", "Other"];
const SEVERITY = ["Low", "Medium", "High", "Critical"];
const REPORTED_BY = ["Telecaller", "Reception", "Doctor", "OT Technician", "Patient Direct"];
const STATUSES = ["Open", "In Progress", "Pending Review", "Resolved", "Closed"];
const FUNNEL = ["Open", "In Progress", "Resolved", "Closed"];

function Funnel({ rows }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {FUNNEL.map((stage) => {
        const count = rows.filter((r) => stage === "Resolved" ? (r.status === "Resolved" || r.status === "Pending Review") : r.status === stage).length;
        const accent = stage === "Open" ? "#DC2626" : stage === "In Progress" ? "#C9A24B" : "#059669";
        return (
          <Card key={stage} data-testid="funnel-stage" className="p-4">
            <p className="text-[10px] uppercase tracking-[0.15em] text-slate-500">{stage}</p>
            <p className="font-display text-3xl font-light mt-2" style={{ color: accent }}>{count}</p>
          </Card>
        );
      })}
    </div>
  );
}

export default function Concerns() {
  const [rows, setRows] = useState([]);
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "branch", label: "Branch" },
    { key: "patient_name", label: "Patient" },
    { key: "issue_type", label: "Issue Type" },
    { key: "severity", label: "Severity", render: (r) => <StatusBadge value={r.severity} /> },
    { key: "reported_by", label: "Reported By" },
    { key: "resolved_by", label: "Resolved By" },
    { key: "time_to_resolve", label: "Resolve (hrs)", render: (r) => r.time_to_resolve ?? "—" },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "satisfied_after", label: "Satisfied?" },
    { key: "source", label: "Source", render: (r) => r.source === "feedback" ? <span className="text-[#C9A24B] text-xs">auto</span> : <span className="text-slate-500 text-xs">manual</span> },
  ];
  const fields = [
    { key: "patient_id", label: "Patient (linked)", type: "patient", full: true },
    { key: "patient_name", label: "Patient Name (or type manually)", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "issue_type", label: "Issue Type", type: "select", options: ISSUE_TYPES },
    { key: "severity", label: "Severity", type: "select", options: SEVERITY },
    { key: "reported_by", label: "Reported By", type: "select", options: REPORTED_BY },
    { key: "status", label: "Status", type: "select", options: STATUSES },
    { key: "time_to_resolve", label: "Time to Resolve (hrs)", type: "number" },
    { key: "resolved_by", label: "Resolved By", type: "text" },
    { key: "satisfied_after", label: "Patient Satisfied After Resolution", type: "select", options: ["Pending", "Y", "N"] },
    { key: "resolution_action", label: "Resolution Action Taken", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="concerns" endpoint="concerns" dateField="date"
      title="Concern & Escalation Log"
      subtitle="Open → In Progress → Resolved → Closed. Critical items alert the Founder. Overdue concerns push to the bell."
      columns={columns} fields={fields}
      defaults={{ severity: "Medium", status: "Open", reported_by: "Patient Direct", satisfied_after: "Pending", source: "manual" }}
      onData={setRows}
      extraTop={<Funnel rows={rows} />}
    />
  );
}
